import PortableMenuText from './PortableMenuText';

export default PortableMenuText;
